import { render, staticRenderFns } from "./RegisterCoupon.vue?vue&type=template&id=e2675a1a"
import script from "./RegisterCoupon.vue?vue&type=script&lang=js"
export * from "./RegisterCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports